// Global imports
import { useEffect, useRef } from 'react'
import { useRootEnvBoolean } from '~/hooks'
import { loadDebug } from '~/utils'

// Types
import type { EnvKey } from '~/hooks/useRootEnvBoolean'

/**
 * useDebugLogger
 *
 * Returns a conditional debug function that only logs when the
 * given environment flag is enabled. Replaces the repeated
 * debugEnabled + debugEnabledRef + debugRef boilerplate.
 */
const useDebugLogger = (envKey: EnvKey) => {
  const debugEnabled = useRootEnvBoolean(envKey)
  const debugEnabledRef = useRef(debugEnabled)
  const debugRef = useRef(loadDebug(debugEnabledRef))

  useEffect(() => {
    debugEnabledRef.current = debugEnabled
  }, [debugEnabled])

  return debugRef
}

export default useDebugLogger
